import React from 'react';
import { 
  List, 
  ListItem, 
  ListItemText, 
  Divider, 
  Box, 
  Typography,
  CircularProgress
} from '@mui/material';
import { useTranslation } from 'next-i18next';
import { FilterAnchorEl, LocationItem } from '../../types/search';
import { LocationPopover as StyledLocationPopover } from './styles';

interface LocationPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  locationCategories: string[];
  onLocationClick: (locationType: string) => void;
  searchResults?: LocationItem[];
  searchMode?: boolean;
  isLoading?: boolean;
  onResultClick?: (location: LocationItem) => void;
}

const LocationPopover: React.FC<LocationPopoverProps> = ({
  open,
  anchorEl,
  onClose,
  locationCategories,
  onLocationClick,
  searchResults = [],
  searchMode = false,
  isLoading = false,
  onResultClick
}) => {
  return (
    <StyledLocationPopover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      disableRestoreFocus
      className={searchMode ? 'searchMode' : ''}
      sx={{ 
        '& .MuiPaper-root': {
          marginTop: '0px'
        }
      }}
    >
      {/* แสดงผลลัพธ์การค้นหาหรือรายการหมวดหมู่สถานที่ */}
      {searchMode ? (
        <Box sx={{ maxHeight: '540px', overflowY: 'auto', paddingBottom: '10px' }}>
          {isLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
              <CircularProgress size={24} sx={{ color: '#F4762A' }} />
            </Box>
          ) : searchResults.length > 0 ? (
            <List dense sx={{ p: 0 }}>
              {searchResults.map((item, index) => (
                <React.Fragment key={item.value || index}>
                  <ListItem 
                    button 
                    onClick={() => onResultClick?.(item)}
                    sx={{ 
                      py: 1.5,
                      '&:hover': { 
                        backgroundColor: '#F4762A10',
                      }
                    }}
                  >
                    <ListItemText 
                      primary={
                        item.rendered ? (
                          <div dangerouslySetInnerHTML={{ __html: item.displayLabel || item.label }} />
                        ) : (
                          item.label
                        )
                      } 
                      primaryTypographyProps={{
                        style: { fontFamily: 'Prompt, sans-serif' }
                      }}
                    />
                  </ListItem>
                  {index < searchResults.length - 1 && <Divider component="li" />}
                </React.Fragment>
              ))}
            </List>
          ) : (
            <Box sx={{ p: 2, textAlign: 'center' }}>
              <Typography>ไม่พบผลลัพธ์ที่ค้นหา</Typography>
            </Box>
          )}
        </Box>
      ) : (
        <Box sx={{ maxHeight: '540px', overflowY: 'auto', paddingBottom: '10px' }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1, p: 1 }}>
            ค้นหาจาก
          </Typography>
          <List dense sx={{ p: 0 }}>
            {locationCategories.map((category, index) => (
              <React.Fragment key={index}>
                <ListItem 
                  button 
                  onClick={() => onLocationClick(category)}
                  sx={{ 
                    py: 1.5,
                    '&:hover': { 
                      backgroundColor: '#F4762A10',
                    }
                  }}
                >
                  <ListItemText 
                    primary={category} 
                    primaryTypographyProps={{
                      style: { fontFamily: 'Prompt, sans-serif' }
                    }}
                  />
                </ListItem>
                {index < locationCategories.length - 1 && <Divider component="li" />}
              </React.Fragment>
            ))}
          </List>
        </Box>
      )}
    </StyledLocationPopover>
  );
};

export default LocationPopover; 